/*=============================================== Fuse options ===============================================*/

export const fuseOptions = {
    isCaseSensitive: false,
    includeMatches: true,
    minMatchCharLength: 1,
}
